import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const OrderReceivingModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'order.orderNo', dataIndex: ['order', 'orderNo'], width: 150, filter:true, sorter:true, title:<Trans>Order No</Trans>});
    columns.push({key:'order.item.itemNo', dataIndex: ['order', 'item', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>MSC Part Number</Trans>});
    columns.push({key:'order.item.name', dataIndex: ['order', 'item', 'name'], width: 200, filter:true, sorter:true, title:<Trans>Item Name</Trans>});
    columns.push({key:'quantity', width: 120, filter:true, sorter:true, title:<Trans>Quantity</Trans>});
    columns.push({key:'order.orderQuantity', dataIndex: ['order', 'orderQuantity'], width: 158, filter:true, sorter:true, title:<Trans>Order Quantity</Trans>});
    columns.push({key:'order.receivedQuantity', dataIndex: ['order', 'receivedQuantity'], width: 171, filter:true, sorter:true, title:<Trans>Received Quantity</Trans>});
    columns.push({key:'source', width: 150, filter:true, sorter:true, title:<Trans>Source</Trans>});
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 200, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/order-receivings"
    };
}
export default OrderReceivingModel();
